import { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import useCloseModalLineMenu from '../../../../../hooks/useCloseModalLineMenu';
import WorkReportLineMenu from '../../../WorkReportActionButtons/WorkReportLineMenu/WorkReportLineMenu';
import ModalLineMenu from '../../../ModalLineMenu/ModalLIneMenu';
import DeleteLineModal from '../../../DeleteLineModal';
import { PositionLinePermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import { LineSummary } from '../../../../../utils/globalPropTypes';
import { checkRol } from '../../../../../security';
import { notificador, proveedorNotificador } from '../../../../../security/constantsRols';

const activeLine = {
  borderRight: '4px solid #3865B8'
};

const LineMonthlyRowContainer = (props) => {
  const {
    position,
    index,
    selectedLine,
    setSelectedLine,
    changeInLine,
    setChangeInLine,
    idWorkLineMonthly,
    positionLinesPermissions,
    disabledEditStateCancelOrFinish
  } = props;

  const { wrapperRef, showModalMenu, setShowModalMenu } = useCloseModalLineMenu();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isProviderOrNotifier = checkRol(proveedorNotificador) || checkRol(notificador);
  const showLineBlockedBySap = position?.bloqueadoEnSap && isProviderOrNotifier;

  return (
    <li
      className="general_row_container form-floating"
      data-index={index}
      // eslint-disable-next-line react/no-unknown-property
      index={index}
      style={index === selectedLine.index ? activeLine : null}
    >
      <Col ref={wrapperRef} sm={12}>
        <div className="d-flex justify-content-between">
          <Col sm={6}>
            <div className="label_row_position">Posición</div>
          </Col>
          <Col className="d-flex justify-content-end position_modal_line_modal_wrapper" sm={6}>
            <WorkReportLineMenu setShowModalMenu={setShowModalMenu} showModalMenu={showModalMenu} />
            <div className="position_modal_line_modal">
              <ModalLineMenu
                disabledByView
                disabledDeleteAction={
                  index !== selectedLine.index || !positionLinesPermissions.deleteLine
                }
                disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                disabledRectifyLine={!positionLinesPermissions.rectifyLine}
                line={{
                  ...position,
                  idParteDiario: idWorkLineMonthly
                }}
                setShowDeleteModal={setShowDeleteModal}
                setShowModalMenu={setShowModalMenu}
                showModalMenu={showModalMenu}
              />
            </div>
          </Col>
        </div>
        <Col
          className="postionLineLabel"
          onClick={() =>
            setSelectedLine({
              ...position,
              index: position.index
            })
          }
        >
          <span className={`${showLineBlockedBySap ? 'text-danger' : ''}`}>
            {`${position.numeroPosicion} - ${position?.descripcionPosicionSap?.toUpperCase()}`}
          </span>
        </Col>
      </Col>
      <Col
        className="mt-2"
        onClick={() =>
          setSelectedLine({
            ...position,
            index: position.index
          })
        }
        sm={12}
      >
        <div className="d-flex justify-content-between">
          <Col sm={9}>
            <div className="label_row_position">Línea</div>
          </Col>
          <Col sm={3}>
            <div className="label_row_position">UM</div>
          </Col>
        </div>
        <div className="d-flex justify-content-between">
          <Col className="postionLineLabel" sm={9}>
            <span className={`${showLineBlockedBySap ? 'text-danger' : ''}`}>
              {`${position.numeroLinea} - ${position?.descripcionLineaSap?.toUpperCase()}`}
            </span>
          </Col>
          <Col sm={3}>
            <span className={`${showLineBlockedBySap ? 'text-danger' : ''}`}>
              {position.unidadMedida}
            </span>
          </Col>
        </div>
      </Col>
      {index === selectedLine.index && <div className="arrow-line-monthly" />}

      <DeleteLineModal
        changeInLines={changeInLine}
        line={{
          ...position,
          idParteDiario: idWorkLineMonthly
        }}
        setChangeInLines={setChangeInLine}
        setNewFetch={setChangeInLine}
        setShowDeleteModal={setShowDeleteModal}
        showDeleteModal={showDeleteModal}
      />
    </li>
  );
};

LineMonthlyRowContainer.propTypes = {
  position: LineSummary.isRequired,
  selectedLine: PropTypes.oneOfType([PropTypes.number, LineSummary]).isRequired,
  setSelectedLine: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  changeInLine: PropTypes.bool.isRequired,
  setChangeInLine: PropTypes.func.isRequired,
  idWorkLineMonthly: PropTypes.number.isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired
};

export default LineMonthlyRowContainer;
